import { apiClient } from '@doda/api-client/util/apiClient';

/**
 * 求人IDをもとに求人一覧を取得
 * @param {string[]} jidList
 * @return {JobListResponse[]} 求人一覧画面
 */
export const getHistoryList = async (jidList: string[]) => {
  const res = await apiClient.api.v1.jobs.$get({
    query: {
      jid: jidList,
    },
  });
  return res;
};
